import { createContext } from 'react';

export interface RootContextInfo {
  loggedIn: ({
    userId,
    userName,
  }: {
    userId: string;
    userName: string;
  }) => void;
  loggedOut: () => void;
}

const root: RootContextInfo = {
  loggedIn: () => {},
  loggedOut: () => {},
};

const RootContext: React.Context<RootContextInfo> = createContext(root);
RootContext.displayName = 'RootContext';

export default RootContext;
